export default "__VITE_ASSET__cv1rvW0A__"